import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import ReliabilityTableSection from './reliabilityTableSection';
import BasicRow from '../identData/basicRow';

import './reliability.scss';

class ReliabilityData extends React.Component {

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? "" : <>
            <div className='columns'>
                <div className='column is-12-desktop'>
                    {this.renderContent(this.props.data)}
                    <div className='reliability-subsections'>
                        {this.renderZSPSTable(this.props.data)}
                    </div>
                </div>
            </div>
        </>);
    }

    renderContent = (data) => {
        return (
            <>
                <div className="ident-data">
                    <BasicRow title="Reliability.Identification.Company" value={data.identification.companyName} />
                    <BasicRow title="Reliability.Identification.CompanyId" value={data.identification.companyId} />
                    <BasicRow title="Reliability.Identification.Address" value={data.identification.fullAddress} />
                    <BasicRow title="Reliability.Identification.CreationDate" value={data.identification.creationDateFormated} />
                    <BasicRow title="Reliability.Identification.DissolutionDate" value={data.identification.dissolutionDateFormatted} />
                    <BasicRow title="Reliability.Identification.Nace" value={data.identification.nace} />
                </div>
            </>
        );
    }

    renderZSPSTable(data) {

        var relations = [];
        data.activityLP.relationTypeGroups.map(d => { relations = relations.concat(d.relations) });

        return (
            <>
                {<ReliabilityTableSection data={relations.sort((a, b) => (a.startDate > b.startDate) ? 1 : ((b.startDate > a.startDate) ? -1 : 0))} sectionName={"Reliability.SectionTitle.LPActivity"} sectionType={"relations"} />}
                {<ReliabilityTableSection data={data.liquidity} sectionName={"Reliability.SectionTitle.Liquidity"} sectionType={"liquidity"} />}
                {<ReliabilityTableSection data={data.criminalRecords} sectionName={"Reliability.SectionTitle.CriminalReg"} sectionType={"warnings"} />}
                {<ReliabilityTableSection data={data.sanctionCNB} sectionName={"Reliability.SectionTitle.CNB"} sectionType={"cnb"} />}
                {<ReliabilityTableSection data={data.interruptionBusiness} sectionName={"Reliability.SectionTitle.InteruptionBusiness"} sectionType={"interuptionBusiness"} />}
                {<ReliabilityTableSection data={data.insolvencyWarnings} sectionName={"Reliability.SectionTitle.Insolvency"} sectionType={"insolvency"} />}
                {<ReliabilityTableSection data={data.tradeInformations.activities} sectionName={"Reliability.SectionTitle.BusinessScope"} sectionType={"trades"} />}
                {<ReliabilityTableSection data={data.registrationRegis} sectionName={"Reliability.SectionTitle.RegisReg"} sectionType={"regisReg"} />}
                {<ReliabilityTableSection data={data.competenceRegis} sectionName={"Reliability.SectionTitle.RegisComp"} sectionType={"regisComp"} />}
                {<ReliabilityTableSection data={data.finalOwners} sectionName={"Reliability.SectionTitle.UltOwner"} sectionType={"owner"} />}
            </>
        )
    }
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ReliabilityData)